module.exports = __webpack_public_path__ + "static/media/logo_pn_invert_en.ee380c8e.svg";